import httpClient from '@api/httpClient'
import type { PaginatedResponse } from '@models/pagination'
import type { Route, RouteFilters, RouteStop } from '@models/route'
import { routesUrls } from './constants'

const getRoutes = async (filters: RouteFilters) => {
  const { data } = await httpClient.get<PaginatedResponse<Route>>(
    routesUrls.root,
    {
      params: filters,
    },
  )
  return data
}

const finishRoute = async ({ routeId }: { routeId: number }) => {
  await httpClient.post(routesUrls.finishRoute(routeId))
}

const unfinishRoute = async ({ routeId }: { routeId: number }) => {
  await httpClient.post(routesUrls.unfinishRoute(routeId))
}

const processPlan = async ({
  companyId,
  depotUserDefinedId,
}: {
  companyId: number
  depotUserDefinedId: string
}) => {
  await httpClient.post(routesUrls.processPlan, {
    companyId,
    depotUserDefinedId,
    withoutPlanDeleting: true,
  })
}

const getStops = async (routeId: number) => {
  const { data } = await httpClient.get<RouteStop[]>(routesUrls.stops(routeId))
  return data
}

export default {
  getRoutes,
  finishRoute,
  unfinishRoute,
  processPlan,
  getStops,
}
